import { Outlet } from 'react-router-dom'
import Sixthgrade_k6_subjects from './sixthgrade_k6_subjects.jsx';
import TopNavbar from '../../components/TopNavbar.jsx';


const Sixthgrade_k6 = ( ) => {
 
  return (
    <>
   
   
<TopNavbar />
  <Sixthgrade_k6_subjects />  
  
     <Outlet />
    
     </>

  )
}

export default Sixthgrade_k6;